// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-stat .icon-stat-icon[data-v-28d14d25]{color:#c1c8cd}.icon-stat .stat[data-v-28d14d25]{color:#11181c;font-weight:400}.icon-stat.align-items-start .icon-stat-icon[data-v-28d14d25]{margin-top:3px}", ""]);
// Exports
module.exports = exports;
